export const tableTypes = {
    generateData_set: '[table] Show Table',
    table_set : '[table] Table Set',
    table_reset: '[table] Table Reset'
};